import { DataBean } from "../DataBean";


export class DOCFileRecordDocument extends DataBean {

    public async getDOCFileRecordDocumentRender(page: number, rows: number, props: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.shared.Report_getDOCFileRecordDocumentRender_Number_Number_java.util.Map", [page, rows, props]);
    }

    public async getDOCFileRecordDocument(iddocfilerecorddocument: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCFileRecordDocument_getDOCFileRecordDocument_Number", [iddocfilerecorddocument]);
    }

    public async getDOCFileRecordDocumentCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCFileRecordDocumentCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCFileRecordDocument(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCFileRecordDocument_updateDOCFileRecordDocument_com.advantage.forms.bean.DOCFileRecordDocument", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCFileRecordDocument"
            }
        ]);
    }

}
